<template>
  <div>
    <div class="dropdown full-width" :class="label">
      <button class="btn btn-outline-filter dropdown-toggle" data-toggle="dropdown" type="button">
        <span>{{ label }} ({{ selectedValues.length }})</span>
      </button>
      <div class="search-dropdown-menu dropdown-menu">
        <input v-model="searchInput" class="form-control mb-3" type="text"
               :placeholder="$t('productivity.filter.search')">
        <div class="option-wrapper">
          <div class="custom-control custom-checkbox" v-for="(possibleValue, index) in getPossibleValuesBySearch"
               :key="'possibleValue'+'-'+index+'_'+ uniqueDOMuid">
            <input v-model="selectedValues"
                   :value="getValueOfPossibleValue(possibleValue)"
                   type="checkbox"
                   :id="'option-'+index+'_'+ uniqueDOMuid"
                   class="custom-control-input"
                   @change="emitChanges($event)"
            >
            <label class="custom-control-label" :for="'option-'+index+'_'+ uniqueDOMuid">
              <span>{{ getLabelOfPossibleValue(possibleValue) }}</span>
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: "SearchDropdown",
  props: ['possibleValues', 'choiceLimit', 'preSelectedValues', 'labelProperty', 'valueProperty', 'label'],
  data() {
    return {
      searchInput: '',
      selectedValues: []
    }
  },
  computed: {
    getPossibleValuesBySearch() {
      return _.filter(this.possibleValues, possibleValue => {
        return this.getLabelOfPossibleValue(possibleValue).toLowerCase().indexOf(this.searchInput.toLowerCase()) > -1;
      })
    }
  },
  methods: {
    getLabelOfPossibleValue(possibleValue) {
      return this.labelProperty ? possibleValue[this.labelProperty] : possibleValue;
    },
    getValueOfPossibleValue(possibleValue) {
      return this.valueProperty ? possibleValue[this.valueProperty] : possibleValue;
    },
    emitChanges(event) {
      if (this.choiceLimit && this.selectedValues.length > this.choiceLimit) {
        this.swalError(this.$tc('searchDropdown.limitReached', this.choiceLimit));
        _.remove(this.selectedValues, value => {
          event.srcElement.checked = false;
          return value === event.srcElement.value;
        })
      }
      this.$emit('changed', this.selectedValues);
    }
  },
  watch: {
    preSelectedValues: {
      deep: true,
      handler() {
        if (this.preSelectedValues) {
          this.selectedValues = this.preSelectedValues;
        }
      }
    }
  },
  created() {
    if (this.preSelectedValues) {
      this.selectedValues = this.preSelectedValues;
    }
  },
  mounted() {
    $('.search-dropdown-menu').on('click', function (e) {
      e.stopPropagation();
    });
  }
}
</script>

<style scoped>
.full-width > button {
  width: 100%;
}

.search-dropdown-menu {
  width: 100%;
}

</style>